export default __webpack_public_path__ + "static/media/Computer.734f0053.svg";